// src/components/ui/topmostDialog.ts
//
// Escape belongs to the TOPMOST open modal only.
//
// Modal and SlideOver each listen for Escape on `document`. When a Modal is
// opened from inside a SlideOver (e.g. "Edit details" on Contact detail), one
// Escape used to close BOTH: the SlideOver's listener was registered first,
// so it fired first, and the Modal's focus return had nowhere left to go.
// Both portal into document.body in open order, so the last aria-modal dialog
// in the document is the one on top.

export function isTopmostModalDialog(el: Element | null): boolean {
  if (!el) return false;
  const open = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
  return open.length > 0 && open[open.length - 1] === el;
}
